import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: () => import('./features/landing/LandingPage.vue') },
    { path: '/app', component: () => import('./views/HomeView.vue') },
    { path: '/candidato/:id', component: () => import('./views/CandidateView.vue') },
    { path: '/r/:slug', component: () => import('./features/shared-report/SharedReportPage.vue') },
    { path: '/metodologia', component: () => import('./views/MethodologyView.vue') },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
  scrollBehavior(to) { return to.hash ? { el: to.hash, behavior: 'smooth', top: 24 } : { top: 0 } },
})
